import { render, staticRenderFns } from "./ModalProducts.vue?vue&type=template&id=05ed44fa"
import script from "./ModalProducts.vue?vue&type=script&lang=js"
export * from "./ModalProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports